<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="clients-create-page-title">
      {{ $t('Settings') }}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered" v-if="showForm">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-client-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-client-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-client-name-label">
                  {{ $t('administration.settings.guide_url') }}
                </label>
                <b-form-input
                  qid="create-user-form-name"
                  type="text"
                  v-model="form.guide_url"
                  required
                  :placeholder="$t('administration.settings.guide_url')"
                ></b-form-input>
              </b-form-group>

            </div>
            <div class="text-right">
              <b-button class=""
                        variant="secondary"
                        @click="showForm = false"
                        qid="activity-edit-button-cancel"
              >
                {{ $t('activities.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class=""
                        :disabled="buttonDisabled"
                        variant="success"
                        qid="create-client-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('administration.users.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
        <div v-if="!showForm">
          <span class="float-right btn-sm btn-edit"
                @click="showForm = true"
                qid="activity-edit-description"
          >
            <font-awesome-icon icon="pen"/>
          </span>
          <div class="form-container">
            <b-form-group>
              <label qid="create-client-name-label">
                {{ $t('administration.settings.guide_url') }}
              </label>
              <div class="">
                <span>{{ guideUrl }}</span>
              </div>
            </b-form-group>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateClient',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('administration.title'),
            to: '/administration'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/administration/settings'
          }
        ],
        form: {
          guide_url: '',
        },
        guideUrl: '',
        showForm: false,
        error: '',
        buttonDisabled: false
      }
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      }
    },
    methods: {
      loadSettings() {
        let self = this;

        piincHttp.get('settings', {}).then(function(response) {
          _.forEach(response.data, function(settings) {
            if(settings.name === 'guide_url'){
              self.form.guide_url = settings.value
              self.guideUrl = settings.value
            }
          })
          self.loading = false;
        }, function() {

        });
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        piincHttp.put('settings', this.form).then(function(response) {
          self.buttonDisabled = false;
          window.location.reload()
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },

    },
    components: {

    },
    created () {
      this.loadSettings();
    }
  }
</script>
